import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, Input, OnInit } from "@angular/core";
import { Order } from "../../models/order_model";
// import { SelectedImgforMobileComponent } from "src/app/views/WebPanel/My Download/My Images for mobile/selected-img-mobile.component";

@Component({
  selector: "app-order-detail-download",
  templateUrl: "./order-detail-download.component.html",
  styleUrls: ["./order-detail-download.component.css"],
})
export class OrderDetailDownloadComponent implements OnInit {
  @Input() title: string;
  @Input() message: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  orderItems: any;
  rows: Order[];

  constructor(
    private activeModal: NgbActiveModal,
    public _DomSanitizationService: DomSanitizer,
    private modalService: NgbModal
  ) {}
  

  ngOnInit() {
    this.orderItems = this.message;
  }

  getSubTotal(price, quantity) {
    let returnPrice = parseFloat(price) * parseFloat(quantity);
    return parseFloat(returnPrice.toString()).toFixed(2);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

   viewImgBtn() {
      //  this.modalService.open(SelectedImgforMobileComponent, {
      //   size: 'lg',
      //   backdrop: 'static',
      //   centered: true
      // });
    }

    

}

